export default __webpack_public_path__ + "ec3d21f38ba718ae66f0d51cc2d42c87.svg";